import { AnchoredSheet, AnchoredSheetTitleBar } from '@shared/components/AnchoredSheet';
import { View } from '@shared/components/View';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { grid } from '@shared/styles';
import { useBoolean } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { MBReactionList } from '../list';
import { MBStackedReactions, MBStackedReactionsProps } from '../stacked';
import classNames from './ReactionsList.module.css';

export function MBStackedReactionsWithList(props: MBStackedReactionsProps) {
  const [isListVisible, showList, hideList] = useBoolean(false);
  const { messageId, reactions } = props;
  const anchorName = `--reactions-${messageId}`;

  return (
    <>
      <MBTouchableOpacity onPress={showList} style={{ alignSelf: 'flex-start' }}>
        <MBStackedReactions {...props} anchorName={anchorName} />
      </MBTouchableOpacity>

      {isListVisible && (
        <AnchoredSheet
          anchorName={anchorName}
          onClose={hideList}
          initialSize="half"
          className={classNames.reactionsListSheet}
          renderTitleBar={() => (
            <AnchoredSheetTitleBar
              title={i18n('common.reactions')}
              rightIcon="exit"
              onRightIconPress={hideList}
              rightIconSize={grid(4)}
            />
          )}
        >
          <View paddingHorizontal={2}>
            <MBReactionList reactions={reactions} />
          </View>
        </AnchoredSheet>
      )}
    </>
  );
}
